import { Tag } from '../types'

export const getTags = (): Tag[] => {
    return [
        {
            tagId: 1,
            tagName: '1',
        },
        {
            tagId: 2,
            tagName: '2',
        },
        {
            tagId: 3,
            tagName: '3',
        },
        {
            tagId: 4,
            tagName: '4',
        },
        {
            tagId: 5,
            tagName: '5',
        },
        {
            tagId: 6,
            tagName: '6',
        },
    ]
}
